/**
 * 可复用listView
 * 目前只支持左右滚动
 */
let ListViewLeft = xClass("ListViewLeft", ccui.ScrollView);

/**
 * delete需要实现的方法：
 *  delegate_getLength: ()=> number 获取列表总长度
 *  delegate_getItemHeight: (index)=> number 获取指定索引值子项高度
 *  delegate_renderItem: (index, view)=> view 渲染一个子视图，view为空时需要delegate自行构建一个新的子项。子项按照锚点(0, 1)设置坐标
 */
ListViewLeft.prototype.ctor = function (delegate) {
    let self = this;
    ccui.ScrollView.prototype.ctor.call(self);
    self.setDirection(ccui.ScrollViewDir.horizontal);
    self.lastScrollX = -self.getInnerContainerPosition().x;
    self.delegate = delegate;

    self.posList = [];
    self.ignoreUp = false;
    self.refresh();
}

ListViewLeft.prototype.onEnter = function () {
    let self = this;
    ccui.ScrollView.prototype.onEnter.call(self);
    // onEnter以后的第一次update跳过，这次update可能是因为changeSize引起的，会导致之前设置的滚动条位置不正确
    self.ignoreUp = true;
}

/**
 * 重置列表
 * @param focusIndex 默认展示位置
 * @param addInnerContainerHeight 额外长度 用于滚动后不想最后一个在最底部
 */
ListViewLeft.prototype.refresh = function (focusIndex = 0, addInnerContainerHeight) {
    let self = this;

    resetPos(self);

    let size = self.getContentSize();
    let innerHeight = Math.max(size.width, self.posList[self.posList.length - 1]);
    if (addInnerContainerHeight &&
        self.posList[self.posList.length - 1] > size.width) {
        innerHeight += addInnerContainerHeight
    }
    self.setInnerContainerSize(cc.size(innerHeight, size.height));

    let pos = self.posList[focusIndex];
    self._jumpToDestination(-pos, self._innerContainer.getPositionY());
    updateViews(self, true);
}

ListViewLeft.prototype.cleanup = function () {
    let self = this;

    self.delegate = null;
    ccui.ScrollView.prototype.cleanup.call(self);
}

ListViewLeft.prototype.update = function (dt) {
    let self = this;
    ccui.ScrollView.prototype.update.call(this, dt);

    updateViews(self);
}

function updateViews(self, forceAll) {
    if (self.ignoreUp) {
        self.ignoreUp = false;
        self._jumpToDestination(self.lastScrollX, self._innerContainer.getPositionY());
        return;
    }

    let curScrollX = -self.getInnerContainerPosition().x;
    if (!forceAll && curScrollX === self.lastScrollX) {
        return;
    }

    let right = self.getContentSize().width + curScrollX, left = curScrollX;
    let topIndex = 0, showCount = 0, innerHeight = self.getInnerContainerSize().width;
    for (let i = 0; i < self.posList.length - 1; i++) {
        if (self.posList[i + 1] <= left) {
            continue;
        } else if (self.posList[i] > right) {
            break;
        } else {
            if (showCount === 0)
                topIndex = i;
            showCount++;
        }
    }

    if (forceAll || showCount === 0) {
        fullAllChildren(self, topIndex, showCount, innerHeight);
    } else {
        let topOutList = [], bottomOutList = [], unVisibleList = [];
        let reuseMap = {};
        let child = null, children = self.getChildren(), reuseCount = 0;
        for (let i = 0; i < children.length; i++) {
            child = children[i];
            if (child.idx === -1) {
                unVisibleList.push(child);
                child.setVisible(false);
            } else if (child.idx < topIndex) {
                topOutList.splice(0, 0, child); // qq上没有reverse方法 -_-!
                child.setVisible(false);
            } else if (child.idx >= topIndex + showCount) {
                bottomOutList.push(child);
                child.setVisible(false);
            } else {
                reuseMap[child.idx] = child;
                child.setVisible(true);
                reuseCount++;
            }
        }

        if (reuseCount < showCount) {
            if (curScrollX > self.lastScrollX) {
                // 向右滚，优先使用底部不可见内容填充
                unVisibleList = topOutList.concat(bottomOutList, unVisibleList);
            } else {
                // 向左滚，优先使用顶部不可见内容填充
                unVisibleList = bottomOutList.concat(topOutList, unVisibleList);
            }

            // 填充未被复用的组件
            for (let i = topIndex; i < topIndex + showCount; i++) {
                if (!reuseMap[i]) {
                    child = unVisibleList.pop();
                    fullChild(self, child, i, innerHeight);
                }
            }
            self.sortAllChildren();
        }
    }

    self.lastScrollX = -self.getInnerContainerPosition().x;
}

function fullAllChildren(self, topIndex, showCount, innerHeight) {
    let child = null, children = self.getChildren();
    for (let i = 0; i < showCount; i++) {
        child = children[i];
        fullChild(self, child, i + topIndex, innerHeight);
    }
    for (let i = showCount; i < children.length; i++) {
        child = children[i];
        child.idx = -1;
        child.setVisible(false);
    }
    self.sortAllChildren();
}

function fullChild(self, child, i, innerHeight) {
    if (child)
        child.setVisible(true);
    child = self.delegate.delegate_renderItem.call(self.delegate, i, child);
    child.idx = i;
    child.setLocalZOrder(i);
    if (child.getParent() == null) {
        self.addChild(child);
    }
    child.setAnchorPoint(0, 0.5);
    child.setPosition(self.posList[i], child.height);
}

/**
 * 计算全部节点的位置信息
 */
function resetPos(self) {
    self.posList.length = 0;

    if (self.delegate) {
        let count = self.delegate.delegate_getLength.call(self.delegate);

        let pos = 0;
        for (let i = 0; i < count; i++) {
            self.posList.push(pos);
            pos = pos + self.delegate.delegate_getItemHeight.call(self.delegate, i);
        }
        self.posList.push(pos);
    }
}


module.exports = ListViewLeft
